class Gallery {
    constructor(section) {
        if (!section) return;
        this.root = section;

        this.init();
    }

    init() {
        this.paginationElement = this.root.querySelector('[js-pagination]');
        this.currentNumberElement =
            this.paginationElement?.querySelector('[js-current]');
        this.loadMoreButton = this.paginationElement?.querySelector(
            '[js-pagination-button-wrapper]'
        );

        this.progressBar = this.root.querySelector('[js-progress-bar]');
        this.galleryItems = this.root.querySelectorAll('[js-gallery-item]');
        this.totalItems = this.galleryItems.length;
        this.itemsPerPage = window.innerWidth > 1023.98 ? 5 : 3;
        this.isDesktopView = window.innerWidth > 1023.98;

        this.paginationReset();
        this.events();
    }

    events() {
        if (this.loadMoreButton) {
            this.loadMoreButton.addEventListener(
                'click',
                this.onLoadMoreButtonClick.bind(this)
            );
        }

        window.addEventListener('resize', this.onWindowResize.bind(this));
    }

    onLoadMoreButtonClick() {
        let possibleActiveElements = this.itemsPerPage;
        this.galleryItems.forEach(element => {
            if (
                possibleActiveElements !== 0 &&
                element.getAttribute('data-active') != '1'
            ) {
                element.setAttribute('data-active', '1');
                element.classList.remove('hidden');
                possibleActiveElements = possibleActiveElements - 1;
            }
        });

        this.activeElements = Array.from(this.galleryItems).filter(
            item => item.getAttribute('data-active') == 1
        );

        this.handlePaginationVisbility();
    }

    onWindowResize() {
        const width = window.innerWidth;

        if (width > 1023.98 && !this.isDesktopView) {
            this.itemsPerPage = 5;
            this.isDesktopView = true;
        } else if (width <= 1023.98 && this.isDesktopView) {
            this.itemsPerPage = 3;
            this.isDesktopView = false;
        } else {
            return;
        }

        this.paginationReset();
    }

    paginationReset() {
        let possibleActiveElements = this.itemsPerPage;
        this.galleryItems.forEach((element, key) => {
            if (key + 1 > possibleActiveElements) {
                element.setAttribute('data-active', '0');
                element.classList.add('hidden');
            } else {
                element.setAttribute('data-active', '1');
                element.classList.remove('hidden');
            }
        });

        this.activeElements = Array.from(this.galleryItems).filter(
            item => item.getAttribute('data-active') == 1
        );

        this.handlePaginationVisbility();
    }

    handlePaginationVisbility() {
        this.currentNumberElement.textContent = this.activeElements.length;
        this.progressBar.style.width = `${
            (this.activeElements.length / this.totalItems) * 100
        }%`;

        if (this.activeElements.length === this.totalItems) {
            this.loadMoreButton.classList.add('hidden!');
        } else {
            this.loadMoreButton.classList.remove('hidden!');
        }
    }
}

const sections = document.querySelectorAll('section.gallery');

if (sections.length) {
    sections.forEach(element => {
        new Gallery(element);
    });
}
